export const FORGET_USER = 'login_user';
export const FORGET_USER_SUCCESSFUL = 'forget_user_successfull';
export const FORGET_PASSWORD_API_FAILED = 'FORGET_PASSWORD_API_FAILED';
export const RESET_PASSWORD_STORE = 'RESET_PASSWORD_STORE';
export const VALIDATE_RESET_TOKEN = 'VALIDATE_RESET_TOKEN';
export const VALIDATE_RESET_TOKEN_SUCCESSFUL = 'VALIDATE_RESET_TOKEN_SUCCESSFUL';
export const VALIDATE_RESET_TOKEN_FAILED = 'VALIDATE_RESET_TOKEN_FAILED';
export const RESET_PASSWORD_FORGOT = 'RESET_PASSWORD_FORGOT';
export const RESET_PASSWORD_FORGOT_SUCCESSFUL = 'RESET_PASSWORD_FORGOT_SUCCESSFUL';
export const RESET_PASSWORD_FORGOT_FAILED = 'RESET_PASSWORD_FORGOT_FAILED';